'use strict';

const Page = require('pages/Page/Page.js');

require('./PageIndex.less');

const IndexHeroLandscape = require('components/IndexHero/IndexHeroLandscape');
const IndexHeroPortrait = require('components/IndexHero/IndexHeroPortrait');
const SectionBlock = require('components/SectionBlock/SectionBlock');

const ChildViews = [
    {
        name: 'indexHeroPortrait',
        Constructor: IndexHeroPortrait
    },
    {
        name: 'indexHeroLandscape',
        Constructor: IndexHeroLandscape
    }
];

module.exports = Page.extend({

    events: {},

    initialize: function (options = {}) {
        Page.prototype.initialize.call(this, options);

        this._initChildViews(ChildViews);

        this.$('.SectionBlock').each((index, item) => {
            new SectionBlock({el: item});
        });
    }
});
